import { useEffect, useRef } from "react";
import VideoPlayer from "./VideoPlayer";

export default function LessonVideo({ src, progressSource = src, mimeType, renditions, title, completed, onProgress }) {
  const ref = useRef(null);
  const callback = useRef(onProgress);
  const state = useRef({ active: false, pending: null, lastSent: "", lastTick: 0 });
  callback.current = onProgress;
  const report = (video, force = false) => {
    if (completed || !video || !Number.isFinite(video.duration) || video.duration <= 0) return;
    const now = performance.now();
    if (!force && now - state.current.lastTick < 10000) return;
    state.current.lastTick = now;
    const ranges = [];
    // played contains only actual playback intervals, unlike currentTime after seeking.
    for (let index = 0; index < video.played.length; index++) {
      if (video.played.end(index) > video.played.start(index)) ranges.push([video.played.start(index), video.played.end(index)]);
    }
    if (!ranges.length) return;
    const payload = { action: "video", videoUrl: progressSource, duration: video.duration, ranges };
    const signature = JSON.stringify(payload);
    if (signature === state.current.lastSent) return;
    state.current.pending = { payload, signature };
    if (state.current.active) return;
    const send = async () => {
      state.current.active = true;
      try {
        while (state.current.pending) {
          const next = state.current.pending;
          state.current.pending = null;
          if (next.signature === state.current.lastSent) continue;
          if (await callback.current(next.payload)) state.current.lastSent = next.signature;
        }
      } finally { state.current.active = false; }
    };
    send();
  };
  useEffect(() => {
    const video = ref.current;
    const flush = () => report(video, true);
    const hidden = () => { if (document.visibilityState === "hidden") flush(); };
    window.addEventListener("pagehide", flush);
    document.addEventListener("visibilitychange", hidden);
    return () => {
      flush();
      window.removeEventListener("pagehide", flush);
      document.removeEventListener("visibilitychange", hidden);
    };
  }, [src]);
  return <VideoPlayer ref={ref} src={src} mimeType={mimeType} renditions={renditions} title={title}
    onTimeUpdate={event => report(event.currentTarget)} onPause={event => report(event.currentTarget, true)}
    onEnded={event => report(event.currentTarget, true)} />;
}
